import { ReactNode } from 'react';

export interface SubOption {
  value: string;
  label: string;
}

export interface BoxType {
  cat: string;
  name: string;
  icon: ReactNode;
  subs: SubOption[];
}

const sameValueSubs = (labels: string[]): SubOption[] => labels.map((label) => ({ value: label, label }));

export const BOX_TYPES: BoxType[] = [
  {
    cat: 'sleeve',
    name: '싸바리박스',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M3 6h18v3H3z" />
        <rect x="4" y="9" width="16" height="11" rx="1" />
        <path d="M10 12h4" />
      </svg>
    ),
    subs: sameValueSubs(['2단형', '3단형', '서랍형', '커스텀', '표지+지함+자석', '카드패키지', '북케이스']),
  },
  {
    cat: 'lid',
    name: '단상자',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 3 4 7v10l8 4 8-4V7z" />
        <path d="m4 7 8 4 8-4" />
        <path d="M12 11v10" />
      </svg>
    ),
    subs: sameValueSubs(['B형', 'G형(C형)', 'M형', 'Y형 상하', 'Y형 + 슬리브', '홀더형', 'A형(택배박스)', '삼각형']),
  },
  {
    cat: 'ready',
    name: '기성박스',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M3 7l2-3h14l2 3" />
        <rect x="3" y="7" width="18" height="13" rx="1" />
        <path d="M10 7v5h4V7" />
      </svg>
    ),
    subs: sameValueSubs([
      '접이식 싸바리박스',
      '싸바리박스 2단',
      '슬리브 싸바리박스',
      '디저트 상자',
      '디저트 상자 캐리어',
      '골판지박스',
      '큐브박스',
      '손잡이상자',
      '위시드 삼각상자',
      '미니박스',
      '원형박스',
    ]),
  },
  {
    cat: 'bag',
    name: '쇼핑백',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="4" y="8" width="16" height="13" rx="1" />
        <path d="M9 8V6a3 3 0 0 1 6 0v2" />
      </svg>
    ),
    subs: [
      { value: '일반', label: '일반형' },
      { value: '매립형', label: '매립형' },
      { value: '타공형', label: '타공형' },
      { value: '커스텀', label: '커스텀' },
    ],
  },
  {
    cat: 'binder',
    name: '바인더',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M3 13 5.5 5.5A2 2 0 0 1 7.4 4h9.2a2 2 0 0 1 1.9 1.5L21 13v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <path d="M3 13h4.5l1.5 2.5h6l1.5-2.5H21" />
      </svg>
    ),
    subs: sameValueSubs(['일반형', '자석형']),
  },
  {
    cat: 'sample',
    name: '샘플북',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M5 18V5a2 2 0 0 1 2-2h11a1 1 0 0 1 1 1v12H7a2 2 0 0 0 0 4h13" />
        <path d="M17 16v4" />
        <path d="M9 8h6M9 11h6" />
      </svg>
    ),
    subs: [
      { value: '2단', label: '2단 형태' },
      { value: '3단', label: '3단 형태' },
      { value: '4단', label: '4단 형태' },
      { value: '커스텀', label: '커스텀' },
      { value: '가방형', label: '가방형' },
    ],
  },
];

export const CONTENT_TYPE_OPTIONS = [
  '화장품 · 스킨케어',
  '색조 · 립스틱',
  '식품 · 디저트',
  '와인 · 주류',
  '쥬얼리 · 액세서리',
  '의류 · 패션 잡화',
  '전자제품',
  '기타',
];

export const BUDGET_OPTIONS = [
  '100만원 미만',
  '100 ~ 300만원',
  '300 ~ 500만원',
  '500 ~ 1,000만원',
  '1,000만원 이상',
  '아직 정하지 못함',
];

export const PRINT_OPTIONS: SubOption[] = [
  { value: '', label: '기본 (4도 컬러)' },
  { value: '+ 별색 인쇄', label: '+ 별색 인쇄' },
  { value: '+ 금박 / 은박', label: '+ 금박 / 은박' },
  { value: '+ 부분 UV', label: '+ 부분 UV' },
  { value: '+ 형압 엠보싱', label: '+ 형압 엠보싱' },
  { value: '+ 밀스톤 (콩 잉크)', label: '+ 밀스톤 (콩 잉크)' },
];

export const ROUTE_OPTIONS: SubOption[] = [
  { value: '네이버 검색', label: '네이버 검색' },
  { value: '구글 검색', label: '구글 검색' },
  { value: '네이버 검색광고', label: '네이버 광고' },
  { value: '인스타그램', label: '인스타그램' },
  { value: '스마트 스토어', label: '스마트 스토어' },
  { value: '스레드', label: '스레드' },
  { value: '네이버 블로그', label: '네이버 블로그' },
  { value: '기타', label: '기타' },
];

export const REFERENCE_OPTIONS = [
  'CM-1229 · GENTLE MONSTER 쥬얼리 싸바리',
  'CM-1539 · MILKTOUCH 듀얼 아이브로우 시딩박스',
  'CM-1241 · LOSY KIM 멜로우 블러싱 세럼 키트',
  "CM-1648 · HIDIFF 비비쿠션 & 립퐁듀 패키지",
  'CM-1649 · TIRTIR 말차라인 시딩 패키지',
  'CM-1592 · ESSENHERB 시딩 단상자',
  "CM-1583 · CHASIN' RABBITS 2단 싸바리",
  'CM-1411 · ABIB PDRN 라인 시딩',
  'CM-1632 · MUMUKI 허니 바나나 3종',
  'CM-1627 · OIAD 워터틴트 시딩',
];
